<template>
    <!-- NEWSLETTER-2
    ============================================= -->
    <section id="newsletter-2" class="pt-60 pb-60 newsletter-section division">
        <div class="container">
            <div class="row d-flex align-items-center row-cols-1 row-cols-lg-2">


                <!-- NEWSLETTER TEXT -->
                <div class="col">
                    <div class="newsletter-txt pr-20">
                        <h3 class="h3-xs">Stay up to date with our news, ideas and updates</h3>
                    </div>
                </div>


                <!-- NEWSLETTER FORM -->
                <div class="col">
                    <form class="newsletter-form">

                        <div class="input-group">
                            <input type="email" autocomplete="off" class="form-control" placeholder="Your email address" required id="s-email">
                            <span class="input-group-btn">
                                <button type="submit" class="btn btn-green black-hover">Subscribe Now</button>
                            </span>
                        </div>

                        <!-- Newsletter Form Notification -->
                        <label for="s-email" class="form-notification"></label>

                    </form>
                </div>	  <!-- END NEWSLETTER FORM -->


            </div>	  <!-- End row -->
        </div>	   <!-- End container -->
    </section>	<!-- END NEWSLETTER-2 -->
</template>
